import { PROPERTIES } from 'email-management-lib/Shared/constants/frameworkTable';
import { EQ, IN } from 'email-management-lib/Shared/utils/filters';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
export default function useInitialFilters({
  queryStringObj,
  shouldAddArchivedFalseFilter
}) {
  const params = useParams();
  return useMemo(() => {
    const filterGroups = [{
      filters: []
    }];
    if (shouldAddArchivedFalseFilter) {
      filterGroups[0].filters.push(IN(PROPERTIES.ARCHIVED, ['false']));
    }
    if (params.folderId) {
      filterGroups[0].filters.push(EQ(PROPERTIES.FOLDER_ID, params.folderId));
    }
    return {
      query: queryStringObj.search,
      filterGroups
    };
  }, [params.folderId, queryStringObj.search, shouldAddArchivedFalseFilter]);
}